import { Component, OnInit } from '@angular/core';
import { Role } from '../role';
import { RoleService } from '../role.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-role',
  templateUrl: './role.component.html',
  styleUrls: ['./role.component.css'],
  providers: [RoleService]
})
export class RoleComponent implements OnInit {

  roles: Role[];
  loading: boolean = false;


  constructor(private roleService: RoleService, private router: Router) { }

   ngOnInit() {
        this.loading = true;
        this.roleService.getRole().subscribe(role=> {this.roles=role['data'];this.loading = false;});
    }

    expose(data: any[]){
      return data['permissions'].map(object=>{return object.display_name+" "}); 
   }   

   add():void {
   		this.router.navigate(['/dashboard/role-crud']);
  }  

   clickedId(id: any){
    	 this.router.navigate(['/dashboard/role-crud/',id]);
  }
}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/roles/role/role.component.ts